import { Bell, ClipboardList, ShieldCheck, Stethoscope, Store, Users } from 'lucide-react';
import { VERTICAL_COMPARISON } from '../comparisonMatrix';
import type { LandingConfig } from '../types';

export const clinicsConfig: LandingConfig = {
  slug: 'clinics',
  namespace: 'landing-clinics',
  analyticsId: 'for-clinics',
  canonicalPath: '/for-clinics',
  ogImagePath: '/images/og-clinics.jpg',
  // No clinic photo yet: shares the doctors hero (see docs/marketing/gym-photo-prompts.md).
  heroImage: '/images/hero-doctors',
  // Order matches landing-clinics:features.items[]
  featureIcons: [Store, Users, Stethoscope, Bell, ClipboardList, ShieldCheck],
  comparison: VERTICAL_COMPARISON,
};
